import { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
// @mui material components
// import Card from "@mui/material/Card";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import MKAlert from "components/MKAlert";
import Icon from "@mui/material/Icon";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import MKInput from "components/MKInput";
import MKButton from "components/MKButton";

// Material Kit 2 PRO React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Pricing page sections
//import Header from "./sections/Header";
import ServicesSection from "./sections/Services";
import CTASection from "./sections/CTASection";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

//--- Images ---
import bg0 from "assets/images/examples/Portia_Helper.jpg";
import bg1 from "assets/images/examples/Elissia_Helper.jpg";
import bg2 from "assets/images/examples/content-1.jpg";
import bg3 from "assets/images/examples/content-2.jpg";
import bg4 from "assets/images/examples/HouseKeeper_Helper.jpg";
import bg5 from "assets/images/examples/Chef_Helper.jpg";
import bg6 from "assets/images/examples/Nanny_Elisia_Helper.jpg";
import heroBg from "assets/images/Board_Helper.jpg";
import { keyframes } from "@mui/system";

//motion
import { motion } from "framer-motion";

function Home() {
  // server from env
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;

  //vars declaration
  const [alertMsg, setAlertMsg] = useState("");
  const [names, setNames] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isSent, setIsSent] = useState(false);

  //--- function to handle submit ---
  const handleContact = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setIsSent(false);
    const data = JSON.stringify({
      names: names,
      email: email,
      phone: phone,
      message: message,
    });

    axios
      .post(SERVER_URL + "/contact/post/", data, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: false,
      })
      .then((res) => {
        if (res.status === 200 && res.data === "Contacted") {
          setAlertMsg("Email Sent!, We'll Get Back to You Very Soon");
          setIsSent(true);
        } else {
          alert("BYANZE, Subscription Yawe");
        }
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const fadeIn = keyframes`
  0% { opacity: 0; transform: translateY(20px); }
  100% { opacity: 1; transform: translateY(0); }
`;

  return (
    <>
      <DefaultNavbar routes={routes} transparent light />
      <MKBox
        component="section"
        minHeight="80vh"
        display="flex"
        alignItems="center"
        justifyContent="center"
        sx={{
          position: "relative",
          width: "100%",
          overflow: "hidden", 
          textAlign: "center",
          py: { xs: 6, md: 8 },
          px: { xs: 2, md: 0 },
        }}
      >
        {/* Background image layer */}
        <MKBox
          sx={{
            position: "absolute",
            inset: "-5%", // allows subtle zoom without overflow
            backgroundImage: `url(${heroBg})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            zIndex: 0,
            transform: "scale(1.05)",
          }}
        />

        {/* Dark overlay */}
        <MKBox
          sx={{
            position: "absolute",
            inset: 0,
            background: "linear-gradient(180deg, rgba(0,0,0,0.65), rgba(0,0,0,0.9))",
            zIndex: 1,
          }}
        />

        {/* Content */}
        <Grid
          container
          justifyContent="center"
          sx={{
            position: "relative",
            zIndex: 2,
            mx: 0, //
            width: "100%",
          }}
        >
          <Grid item xs={12} md={10} lg={8}>
            {/* Title */}
            <MKTypography
              variant="h2"
              color="white"
              fontWeight="bold"
              mb={2}
              sx={{
                textTransform: "uppercase",
                letterSpacing: "2px",
                fontSize: { xs: "2rem", sm: "2.6rem", md: "3.2rem" },
                animation: `${fadeIn} 0.9s ease forwards`,
              }}
            >
              The Best Helper
            </MKTypography>

            {/* CTA Button */}
            <MKBox
              display="flex"
              justifyContent="center"
              mb={4}
              sx={{ animation: `${fadeIn} 1.1s ease forwards` }}
            >
              <Link to="/services/booking" style={{ textDecoration: "none" }}>
                <MKButton
                  size="large"
                  sx={{
                    background: "linear-gradient(135deg, #700808, #9b1c1c)",
                    color: "#fff",
                    borderRadius: "999px",
                    px: 7,
                    py: 2,
                    fontSize: "1rem",
                    fontWeight: 700,
                    letterSpacing: "1px",
                    boxShadow: "0 12px 30px rgba(112,8,8,0.45)",
                    transition: "all 0.35s ease",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: "0 18px 45px rgba(112,8,8,0.6)",
                    },
                  }}
                >
                  Request Assistance
                </MKButton>
              </Link>
            </MKBox>

            {/* Description */}
            <MKTypography
              color="white"
              mb={3}
              sx={{
                maxWidth: "720px",
                mx: "auto",
                opacity: 0.9,
                lineHeight: 1.8,
                fontSize: { xs: "0.95rem", sm: "1.05rem", md: "1.15rem" },
                animation: `${fadeIn} 1.3s ease forwards`,
              }}
            >
              Your trusted partner for a smooth and stress-free stay in East Africa. We assist locals,
              foreigners, and diaspora in finding essential services from the moment they arrive.
            </MKTypography>

            {/* Countries */}
            <MKBox
              display="flex"
              justifyContent="center"
              gap={{ xs: 1.5, sm: 2.5 }}
              flexWrap="wrap"
              mt={4}
              sx={{ animation: `${fadeIn} 1.5s ease forwards` }}
            >
              {["Rwanda", "Kenya", "Uganda", "Tanzania"].map((country) => (
                <MKBox
                  key={country}
                  px={2.5}
                  py={0.9}
                  sx={{
                    borderRadius: "999px",
                    background: "rgba(255,255,255,0.12)",
                    backdropFilter: "blur(8px)",
                    border: "1px solid rgba(255,255,255,0.25)",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      background: "rgba(255,255,255,0.22)",
                      transform: "translateY(-2px)",
                      boxShadow: "0 8px 20px rgba(0,0,0,0.25)",
                    },
                  }}
                >
                  <MKTypography
                    variant="button"
                    color="white"
                    fontWeight="medium"
                    sx={{
                      fontSize: { xs: "0.8rem", sm: "0.95rem" },
                      letterSpacing: "0.5px",
                    }}
                  >
                    {country}
                  </MKTypography>
                </MKBox>
              ))}
            </MKBox>
          </Grid>
        </Grid>
      </MKBox>

      <MKBox
        component="section"
        py={{ xs: 8, md: 12 }}
        sx={{
          background: "linear-gradient(180deg, #ffffff 0%, #ffffff 100%)",
        }}
      >
        <Container>
          {/* Centered Intro */}
          <Grid container justifyContent="center" textAlign="center" mb={8}>
            <Grid item xs={12} md={8}>
              <MKTypography variant="h3" fontWeight="bold" mb={2} sx={{ color: "#003060" }}>
                Life Made Simple
              </MKTypography>

              <MKTypography
                variant="body1"
                sx={{
                  maxWidth: 640,
                  mx: "auto",
                  opacity: 0.8,
                  fontSize: { xs: "1rem", md: "1.125rem" },
                  lineHeight: 1.6,
                }}
              >
                From arrival to everyday living, we help you feel at home across East Africa.
              </MKTypography>
            </Grid>
          </Grid>

          {/* Image Grid */}
          <Grid container spacing={3} justifyContent="center">
            {[bg6, bg4, bg5, bg1, bg3, bg2].map((bg, idx) => (
              <Grid item xs={12} sm={6} md={4} key={idx}>
                <motion.div
                  initial={{ opacity: 0, y: 25 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: idx * 0.1 }}
                >
                  <MKBox
                    sx={{
                      aspectRatio: "1 / 1",
                      borderRadius: "1.75rem",
                      backgroundImage: `url(${bg})`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      position: "relative",
                      overflow: "hidden",
                      transition: "all 0.45s ease",
                      "&:hover": {
                        transform: "translateY(-6px) scale(1.03)",
                        boxShadow: "0 20px 45px rgba(0,0,0,0.25)",
                      },
                      "&:after": {
                        content: '""',
                        position: "absolute",
                        inset: 0,
                        background: "linear-gradient(180deg, rgba(0,0,0,0.0), rgba(0,0,0,0.35))",
                        opacity: 0,
                        transition: "opacity 0.4s ease",
                      },
                      "&:hover:after": {
                        opacity: 1,
                      },
                    }}
                  />
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Container>
      </MKBox>

      <ServicesSection />
      <MKBox
        component="section"
        py={{ xs: 8, md: 12 }}
        sx={{
          background: "linear-gradient(180deg, #ffffff 0%, #ffffff 100%)",
        }}
      >
        <Container>
          {/* Section Header */}
          <Grid
            container
            item
            xs={12}
            lg={8}
            justifyContent="center"
            sx={{ mx: "auto", textAlign: "center", mb: 8 }}
          >
            <MKTypography
              variant="h3"
              fontWeight="bold"
              textAlign="center"
              mb={2}
              sx={{ color: "#003060" }}
            >
              Why Choose Us
            </MKTypography>

            <MKTypography
              variant="body1"
              textAlign="center"
              mb={7}
              sx={{ maxWidth: 640, mx: "auto", opacity: 0.8 }}
            >
              We remove the stress of settling in a new place by offering dependable,
              lifestyle-focused services designed to adapt to your needs.
            </MKTypography>
          </Grid>

          {/* Feature Cards */}
          <Grid container spacing={4} justifyContent="center">
            {[
              {
                icon: "groups",
                title: "Expert Team",
                description:
                  "Experienced professionals committed to delivering personalized support every step of your journey.",
              },
              {
                icon: "support_agent",
                title: "Always Available",
                description:
                  "Round-the-clock assistance to ensure you’re never left without guidance or help.",
              },
              {
                icon: "tune",
                title: "Flexible Services",
                description:
                  "Our services adjust to your plans, preferences, and lifestyle—whenever things change.",
              },
            ].map((item, idx) => (
              <Grid item xs={12} md={6} lg={4} key={idx}>
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.6, delay: idx * 0.15 }}
                >
                  <MKBox
                    p={4}
                    textAlign="center"
                    height="100%"
                    sx={{
                      background: "#ffffff",
                      borderRadius: "1.75rem",
                      border: "1px solid rgba(0,0,0,0.06)",
                      boxShadow: "0 10px 30px rgba(0,0,0,0.06)",
                      transition: "all 0.35s ease",
                      "&:hover": {
                        transform: "translateY(-8px)",
                        boxShadow: "0 20px 45px rgba(0,0,0,0.12)",
                      },
                    }}
                  >
                    {/* Icon */}
                    <MKBox
                      mx="auto"
                      mb={3}
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                      sx={{
                        width: 70,
                        height: 70,
                        borderRadius: "18px",
                        background: "linear-gradient(135deg, #700808, #9b1c1c)",
                        color: "#fff",
                        fontSize: "2rem",
                        boxShadow: "0 8px 25px rgba(112,8,8,0.35)",
                      }}
                    >
                      <Icon>{item.icon}</Icon>
                    </MKBox>

                    {/* Title */}
                    <MKTypography variant="h5" fontWeight="bold" mb={1.5} sx={{ color: "#003060" }}>
                      {item.title}
                    </MKTypography>

                    {/* Description */}
                    <MKTypography variant="body2" sx={{ opacity: 0.8, lineHeight: 1.7 }}>
                      {item.description}
                    </MKTypography>
                  </MKBox>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </Container>
      </MKBox>
      <CTASection />
      <MKBox
        component="section"
        display="grid"
        position="relative"
        minHeight="90vh"
        borderRadius="xl"
        mr={{ xs: 0, lg: 8 }}
        mb={{ xs: 0, lg: -2 }}
        mt={{ xs: 0, lg: 5 }}
        sx={{ overflow: { xs: "hidden", lg: "visible" }, placeItems: "center" }}
      >
        {/* Background Image */}
        <MKBox
          component="img"
          alt="Helper Everywhere"
          src={bg0}
          width={{ xs: "100%", lg: "50%" }}
          height={{ xs: "100%", lg: "100%" }}
          position="absolute"
          right={0}
          bottom={{ xs: "-25%", lg: "unset" }}
          top={{ xs: 0, lg: "unset" }}
          sx={{
            objectFit: "cover",
            borderTopLeftRadius: ({ borders: { borderRadius } }) => ({
              xs: 0,
              lg: borderRadius.lg,
            }),
          }}
        />

        <Container>
          <Grid container spacing={{ xs: 0, lg: 3 }} sx={{ mt: { xs: 0, lg: 12 } }}>
            <Grid item xs={12} lg={7} justifyContent="center" flexDirection="column">
              {/* White Card */}
              <MKBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                flexDirection="column"
                shadow="xl"
                borderRadius="xl"
                sx={{
                  backgroundColor: ({ palette: { white } }) => white.main, // solid white
                  px: { xs: 4, sm: 8 },
                  py: { xs: 4, sm: 10 },
                  mb: { xs: 0, lg: 8 },
                  mt: { xs: 0, lg: -6 },
                  boxShadow: "0 12px 40px rgba(0,0,0,0.15)", // modern Apple-like shadow
                  position: "relative", // make sure it's positioned above the image
                  zIndex: 1, // set a higher z-index than the image
                }}
              >
                {/* Title */}
                <MKTypography
                  variant="h3"
                  textAlign="center"
                  mb={2}
                  fontWeight="bold"
                  sx={{ letterSpacing: "0.5px" }}
                >
                  Contact Us
                </MKTypography>

                {/* Form */}
                <MKBox component="form" role="form" onSubmit={handleContact} autoComplete="off">
                  {alertMsg.length > 0 && (
                    <motion.div
                      initial={{ x: -200, opacity: 0 }}
                      animate={{ x: 0, opacity: 1 }}
                      transition={{ duration: 1.2, ease: "easeOut" }}
                    >
                      <MKAlert color="primary">{alertMsg}</MKAlert>
                    </motion.div>
                  )}

                  <MKBox py={3} px={{ xs: 2, md: 10, lg: 6, xl: 10 }}>
                    <Grid container spacing={3} sx={{ mb: 3 }}>
                      <Grid item xs={12} md={6}>
                        <MKInput
                          variant="standard"
                          placeholder="Your Name"
                          label="Name"
                          onChange={(e) => setNames(e.target.value)}
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <MKInput
                          variant="standard"
                          placeholder="Phone Number"
                          label="Telephone"
                          onChange={(e) => setPhone(e.target.value)}
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <MKInput
                          variant="standard"
                          type="email"
                          placeholder="Email Address"
                          label="Email"
                          onChange={(e) => setEmail(e.target.value)}
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12}>
                        <MKInput
                          variant="standard"
                          label="Your Message"
                          onChange={(e) => setMessage(e.target.value)}
                          rows={5}
                          multiline
                          InputLabelProps={{ shrink: true }}
                          fullWidth
                        />
                      </Grid>
                    </Grid>

                    <Grid container>
                      <Grid item xs={12}>
                        <MKButton
                          variant="gradient"
                          color={isSent ? "info" : "primary"}
                          type="submit"
                          fullWidth
                          disabled={isLoading || isSent}
                          sx={{ py: 1.8, fontWeight: "bold", fontSize: "1rem" }}
                        >
                          {isLoading ? "Sending Email..." : isSent ? "Email Sent" : "Send Message"}
                        </MKButton>
                      </Grid>
                    </Grid>
                  </MKBox>
                </MKBox>
              </MKBox>
            </Grid>
          </Grid>
        </Container>
      </MKBox>

      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default Home;
